import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-entitlements',
  templateUrl: './employee-entitlements.component.html'
  
})
export class EmployeeEntitlementsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/employee-entitlements/employee-entitlements.component.ts